module.exports = __webpack_public_path__ + "static/media/create-workspace-arrow.da3dae0f.svg";